module.exports = __webpack_public_path__ + "img/productVibration_4.e1f7ec2a.png";